import { render, staticRenderFns } from "./ProgramChat.vue?vue&type=template&id=c8634954&scoped=true"
import script from "./ProgramChat.vue?vue&type=script&lang=js"
export * from "./ProgramChat.vue?vue&type=script&lang=js"
import style0 from "./ProgramChat.vue?vue&type=style&index=0&id=c8634954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8634954",
  null
  
)

export default component.exports